import React from "react";
import PropTypes from "prop-types";
import { withClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "../../styles.css";
var SuggestionContainer = function SuggestionContainer(_ref) {
  var children = _ref.children,
    classes = _ref.classes;
  return /*#__PURE__*/React.createElement("div", {
    className: classes['list-container']
  }, children);
};
process.env.NODE_ENV !== "production" ? SuggestionContainer.propTypes = {
  children: PropTypes.node,
  classes: classesPropType(['container', 'is-open', 'list-container', 'list', 'item', 'item-is-disabled', 'item-is-active'])
} : void 0;
export default withClasses(styles)(SuggestionContainer);